import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';

@Component({
    selector: 'app-screenshare-container',
    templateUrl: './screenshare-container.component.html',
    styleUrls: ['./screenshare-container.component.scss'],
    standalone: false
})
export class ScreenshareContainerComponent implements OnInit {
  @Input() screenShareElement: any;
  @ViewChild('screenShareContainer', {static: false})screenShareContainer!:ElementRef;
  

  constructor() { }

  ngOnInit(): void {}

  ngAfterViewInit(){
    if(this.screenShareElement){
      // this.screenShareContainer.nativeElement.appendChild(this.screenShareElement);
      const previewDiv: HTMLElement = this.screenShareContainer.nativeElement;
      const videoElement: HTMLElement = this.screenShareElement;
      previewDiv.classList.add('lvsScreenShareContainer');
      previewDiv.appendChild(videoElement);
    }
  }

}
